import instance from "~/v2/api";
import { looseArray, looseParse } from "~/v2/api/looseParse";
import { queryKeys } from "~/v2/api/queryKeys";
import { type OrderFill, orderFillSchema } from "./orderFills.schema";

export type OrderFillsProduct = "live" | "paper";

export const ORDER_FILLS_PAGE_SIZE = 20;
export const ORDER_FILLS_REQUEST_PAGE_SIZE = ORDER_FILLS_PAGE_SIZE + 1;
export const ORDER_FILLS_ACTIVITY_TYPE = "FILL";
export const ORDER_FILLS_DIRECTION = "asc";

export interface GetAtdOrderFillsParams {
  accountID: string;
  product: OrderFillsProduct;
  orderID: string;
  pageSize?: number;
  pageToken?: string;
}

export interface OrderFillsQueryKeyParams {
  accountID: string;
  product?: OrderFillsProduct;
  orderID: string;
  pageToken?: string;
}

export const orderFillsQueryKeys = {
  all: [...queryKeys.activities.all, "order-fills"] as const,
  page: ({
    accountID,
    product,
    orderID,
    pageToken,
  }: OrderFillsQueryKeyParams) =>
    [
      ...orderFillsQueryKeys.all,
      accountID,
      orderID,
      product,
      pageToken,
    ] as const,
};

export const getOrderFillsPath = (
  accountID: string,
  product: OrderFillsProduct,
): string =>
  `/${product === "live" ? "accounts" : "paper_accounts"}/${accountID}/activities`;

export const getAtdOrderFills = async ({
  accountID,
  product,
  orderID,
  pageSize = ORDER_FILLS_REQUEST_PAGE_SIZE,
  pageToken,
}: GetAtdOrderFillsParams): Promise<OrderFill[]> => {
  const params: Record<string, string | number> = {
    order_id: orderID,
    activity_types: ORDER_FILLS_ACTIVITY_TYPE,
    direction: ORDER_FILLS_DIRECTION,
    page_size: pageSize,
  };
  if (pageToken) {
    params.page_token = pageToken;
  }

  const { data } = await instance.get(getOrderFillsPath(accountID, product), {
    params,
  });

  return looseParse(
    looseArray(orderFillSchema, "v3.getAtdOrderFills"),
    data,
    "v3.getAtdOrderFills",
  );
};
